import $ from "jquery";
import Vue from "vue";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as rt from "../../../routes/routes";
import * as ses from "../../../configurations/session/sessioncomplete";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router/index";

export const actions = {
  newPettycash() {
    let pettycashDetails = {
      disbursed_amount: $(".disbursed_amount").val(),
      account_id: $(".account_id").val()
    };
    $(".creatingPettycash").hide();
    $(".creatingPettycashLoader").show();
    baseurl.post(rt.newPettycash, pettycashDetails).then(res => {
      $(".creatingPettycash").show();
      $(".creatingPettycashLoader").hide();

      //checking for response codes from backend api
      
      if (res.data.code === 200) {
        //success code
        suc.pettycashCreateSuccess();
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 404) {
        //eror on creating data
        ers.errorCreatingPettycash();
      } else if (res.data.code === 405) {
        //no permission to create
        ers.noPermissionToCreate();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },

  loadPettycash({ commit }) {
    baseurl.get(rt.loadPettycashes).then(res => {
      $(".pettycashesLoader").hide();

      //checking response codes from backend api

      if (res.data.code === 200) {
        //succes code and mutations
        commit("STORE_PETTYCASHES", res.data.pettycashes);
      } else if (res.data.code === 404) {
        //error on loading data
        ers.errorLoadingPettycash();
      } else if (res.data.code === 405) {
        commit("STORE_PETTYCASHES", []);
        router.push("/dashboard");
        //no permission to read
        ers.noPermissionToRead();
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/pettycashes/actions.js